import { get } from "lodash";
import { createSelector } from "reselect";
import { getPageContent } from "../../shared/selectors";

const getUnitProspectList = createSelector([getPageContent], pageContent => {
  return get(pageContent, "unit_prospects", []);
});

export default getUnitProspectList;
